export default __webpack_public_path__ + "static/media/paw-print-pin-gray.43d9603b.svg";